/* eslint-disable max-len */

import { getCookieByName, getEnvironmentVariables } from "./general";
import type { Language } from "../types";

export function persistLanguage (item: Language){
  const { corporateDomain } = getEnvironmentVariables();

  document.cookie = `languageStored=${JSON.stringify(item)}; domain=${corporateDomain}; path=/; max-age=31536000`;
}

export function getLanguage() {
  const itemStored = getCookieByName("languageStored");

  if (itemStored) {
    return JSON.parse(itemStored) as Language;
  } else {
    return undefined;
  }
}

export function getLanguageDisplayNames(codes: string[], locale: string): string[] {
  const displayNames = new Intl.DisplayNames([locale], { type: "language" });

  return codes
    .map((code) => displayNames.of(code))
    .filter((name): name is string => Boolean(name))
    .map((name) => name.charAt(0).toUpperCase() + name.slice(1));
}
